import { Box, Dropdown, DropdownOption, Text } from "@modernatx-internal/component-library";
import React from "react";

import { ContentComponentProps, ProvinceEligibilitySelectorContent } from "@/content-V2/types";

const CA_EN_REGION_OPTIONS: DropdownOption[] = [
  { label: "Alberta", value: "AB" },
  { label: "British Columbia", value: "BC" },
  { label: "Manitoba", value: "MB" },
  { label: "New Brunswick", value: "NB" },
  { label: "Newfoundland and Labrador", value: "NL" },
  { label: "Northwest Territories", value: "NT" },
  { label: "Nova Scotia", value: "NS" },
  { label: "Nunavut", value: "NU" },
  { label: "Ontario", value: "ON" },
  { label: "Prince Edward Island", value: "PE" },
  { label: "Quebec", value: "QC" },
  { label: "Saskatchewan", value: "SK" },
  { label: "Yukon", value: "YT" }
];

const CA_FR_REGION_OPTIONS: DropdownOption[] = [
  { label: "Alberta", value: "AB" },
  { label: "Colombie-Britannique", value: "BC" },
  { label: "Manitoba", value: "MB" },
  { label: "Nouveau-Brunswick", value: "NB" },
  { label: "Terre-Neuve-et-Labrador", value: "NL" },
  { label: "Nouvelle-Écosse", value: "NS" },
  { label: "Territoires du Nord-Ouest", value: "NT" },
  { label: "Nunavut", value: "NU" },
  { label: "Ontario", value: "ON" },
  { label: "Île-du-Prince-Édouard", value: "PE" },
  { label: "Québec", value: "QC" },
  { label: "Saskatchewan", value: "SK" },
  { label: "Yukon", value: "YT" }
];

export const ProvinceEligibilitySelector: React.FC<
  ContentComponentProps<ProvinceEligibilitySelectorContent>
> = ({
  areaSelectionText,
  backgroundColor = "surface-brand-secondary",
  eligibilitySummaryText,
  fullWidthOnMobile = false,
  provinceEligibilityResult,
  resultDefaultText,
  lang = "en"
}) => {
  const [selectedOption, setSelectedOption] = React.useState<DropdownOption | undefined>();
  const [result, setResult] = React.useState<React.ReactNode | undefined>();

  const onSelectOption = React.useCallback(
    (option: DropdownOption | null) => {
      if (!option) {
        setSelectedOption(undefined);
        setResult(undefined);
        return;
      }
      const selectedResult =
        provinceEligibilityResult.find(({ region }) => region === option.value)?.eligibility ||
        undefined;

      setSelectedOption(option);
      setResult(selectedResult);
    },
    [provinceEligibilityResult]
  );

  return (
    <Box
      sx={{
        p: "spacing-7",
        borderRadius: "radius-2",
        backgroundColor,
        gap: 2
      }}
    >
      <Text variant={"body-1-bold"}>{areaSelectionText}</Text>
      <Dropdown
        sx={{ width: fullWidthOnMobile ? ["100%", null, 75] : 75, py: 2 }}
        label={lang === "en" ? "Area" : "Région"}
        dropdownOptions={lang === "en" ? CA_EN_REGION_OPTIONS : CA_FR_REGION_OPTIONS}
        selectedOption={selectedOption}
        onSelectOption={onSelectOption}
      />
      <Text variant={"body-1-bold"}>{eligibilitySummaryText}</Text>
      {result ? (
        <Box>
          <Text variant={"body-1-regular"}>{result}</Text>
        </Box>
      ) : (
        <Text variant={"body-1-regular"}>{resultDefaultText}</Text>
      )}
    </Box>
  );
};
